import {t as coreT} from "@intermesh/goui";

export function t(key: string) {
	return coreT(key, "business", "forms");
}